import axios from "axios";

export const API_DOMAIN = process.env.REACT_APP_TPOC_API_DOMAIN;

export const LOCAL_LOAN_ID = process.env.REACT_APP_LOCAL_LOAN_ID || "";

export const LOCAL_USER_ID = process.env.REACT_APP_LOCAL_USER_ID || "";

export const isLocalEncompassMode = () => {
    const hostname = window.location.hostname.toLowerCase();

    return process.env.REACT_APP_USE_LOCAL_ENCOMPASS_DATA === "true" || process.env.NODE_ENV === "development" || hostname === "localhost" || hostname === "127.0.0.1";
};

export const getEncompassAuthObject = async () => {
    if (!window.elli?.script?.getObject) {
        throw new Error("Encompass auth object is not available.");
    }

    return window.elli.script.getObject("auth");
};

export const getEncompassAuthCode = async () => {
    if (isLocalEncompassMode()) {
        return "test";
    }

    const authObject = await getEncompassAuthObject();

    return authObject.createAuthCode();
};

export const getEncompassCurrentUser = async () => {
    if (isLocalEncompassMode()) {
        return null;
    }

    const authObject = await getEncompassAuthObject();

    return authObject.getUser();
};

const elliemaeApi = axios.create({
    baseURL: process.env.REACT_APP_ICE_API_BASE_URL
});

export default elliemaeApi;
